import { leerNumero } from '../formato'

/** De fraccion a lo que se escribe: 0.45 -> 45 (sin el 45.00000000000001 de los decimales). */
export const porcentaje = (fraccion: number) => Number((fraccion * 100).toFixed(2))

/**
 * Lo escrito -> lo que se manda al servidor. `null` = "la de siempre" (vacio, o igual a la
 * que viene por defecto: asi, si manana cambia el 45 %, las cotizaciones sin tocar lo siguen).
 * Un texto es un error para mostrar.
 */
export function leerUtilidad(texto: string, porDefecto: number | undefined): number | null | string {
  const n = leerNumero(texto)
  if (n === null) return null
  if (Number.isNaN(n) || n < 0 || n > 200) return 'La utilidad va en %, entre 0 y 200 (por ejemplo 45).'
  if (porDefecto !== undefined && Math.abs(n - porcentaje(porDefecto)) < 1e-9) return null
  return n / 100
}

interface Props {
  valor: string
  alCambiar: (valor: string) => void
  /** La utilidad que se aplica si no se toca (la del motor). */
  porDefecto?: number
}

/** La utilidad sobre costo de ESTA cotizacion. Por defecto la de siempre (45 %); se puede cambiar. */
export function CampoUtilidad({ valor, alCambiar, porDefecto }: Props) {
  const defecto = porDefecto === undefined ? '' : ` Por defecto ${porcentaje(porDefecto)} %.`
  return (
    <label>
      Utilidad sobre costo (%)
      <input value={valor} onChange={(e) => alCambiar(e.target.value)} inputMode="decimal" />
      <small className="ayuda">
        Se aplica a todas las partidas, también a los valores manuales.{defecto} Cámbiala solo para esta cotización.
      </small>
    </label>
  )
}
